// TOP LEVEL IMPORTS
import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
// COMPONENTS
import ActionLink from 'components/text/ActionLink';
// APOLLO
import { graphql, compose } from 'react-apollo';
import invoicesQuery from 'ApolloClient/Queries/invoices';
import invoicesByClientIdQuery from 'ApolloClient/Queries/invoicesByClientId';
import createInvoice from 'ApolloClient/Mutations/createInvoice';

class CreateInvoiceButton extends React.Component {
  onClick = evt => {
    evt.preventDefault();

    const { clientId, history } = this.props;

    const variables = { params: { clientId } };
    const refetchQueries = [
      {
        query: invoicesByClientIdQuery,
        variables: { _id: clientId },
      },
      {
        query: invoicesQuery,
      },
    ];

    this.props
      .createInvoice({ variables, refetchQueries })
      .then(({ data }) => {
        history.push(`/invoice/create/1/${data.createInvoice._id}`);
      })
      .catch(err => console.log(err));
  };

  render() {
    return <ActionLink onClick={this.onClick}>NEW INVOICE</ActionLink>;
  }
}

CreateInvoiceButton.propTypes = {
  clientId: PropTypes.string.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
  createInvoice: PropTypes.func.isRequired,
};

const enhance = compose(
  withRouter,
  graphql(createInvoice, { name: 'createInvoice' }),
);

export default enhance(CreateInvoiceButton);



// WEBPACK FOOTER //
// ./src/routes/app-client-detail/ClientInvoices/CreateInvoiceButton/index.js